import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import Header from "../Header";
import "./tpl.css";
import "./Profile.css";
import axios from "axios";
import API_BASE_URL from "../../config";
import { BsCheckCircleFill, BsXCircleFill } from "react-icons/bs";

export default function Profile() {
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saveStatus, setSaveStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("userToken");
        if (!token) { window.location.href = "/login"; return; }
        const headers = { Authorization: `Bearer ${token}` };
        const res = await axios.get(`${API_BASE_URL}/profile`, { headers });
        setUser(res.data);
        setFormData(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching user:", err.response?.data || err.message);
        setError("Failed to load user details.");
        setLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem("userToken");
      const headers = { Authorization: `Bearer ${token}` };
      await axios.put(`${API_BASE_URL}/profile/${user.user_id}`, formData, { headers });
      setUser({ ...user, ...formData });
      setSaveStatus("success");
      setTimeout(() => setSaveStatus(null), 3000);
    } catch (err) {
      console.error("Error updating user:", err.response?.data || err.message);
      setSaveStatus("error");
      setTimeout(() => setSaveStatus(null), 3000);
    } finally {
      setSaving(false);
    }
  };

  const hasChanges = user && (
    formData.first_name !== user.first_name || formData.last_name !== user.last_name ||
    formData.email !== user.email || formData.phone !== user.phone
  );

  return (
    <div className="page-container">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="container mt-4">
          <div className="page-header dash-head">
            <div>
              <h4>Profile</h4>
              <p className="page-subtitle">Your personal details.</p>
            </div>
            {!loading && !error && (
              <button className="tpl-cta" onClick={handleSave} disabled={!hasChanges || saving}>
                {saving ? "Saving…" : "Save changes"}
              </button>
            )}
          </div>

          {loading ? (
            <div className="page-loading"><div className="spinner" /><p>Loading profile…</p></div>
          ) : error ? (
            <div className="page-error"><BsXCircleFill size={32} /><p>{error}</p></div>
          ) : (
            <div className="tpl-grid2">
              <div className="tpl-card">
                <div className="tpl-card-h"><h6>Details</h6></div>
                <div className="tpl-fields">
                  <div className="tpl-fgrid">
                    <div className="tpl-field">
                      <label>First name</label>
                      <input name="first_name" value={formData.first_name || ""} onChange={handleChange} placeholder="First name" />
                    </div>
                    <div className="tpl-field">
                      <label>Last name</label>
                      <input name="last_name" value={formData.last_name || ""} onChange={handleChange} placeholder="Last name" />
                    </div>
                  </div>
                  <div className="tpl-field">
                    <label>Email</label>
                    <input type="email" name="email" value={formData.email || ""} onChange={handleChange} placeholder="Email" />
                  </div>
                  <div className="tpl-field">
                    <label>Phone</label>
                    <input name="phone" value={formData.phone || ""} onChange={handleChange} placeholder="Phone number" />
                  </div>
                </div>
              </div>

              <div className="tpl-card">
                <div className="tpl-card-h"><h6>Account</h6></div>
                <div className="pf-acc">
                  <div className="pf-acc-avatar">
                    {`${(user.first_name || "")[0] || ""}${(user.last_name || "")[0] || ""}`.toUpperCase()}
                  </div>
                  <div className="pf-acc-name">{user.first_name} {user.last_name}</div>
                  <div className="pf-acc-email">{user.email}</div>
                  {user.role && <span className="tpl-tag info" style={{ marginTop: 8 }}>{user.role}</span>}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {saveStatus && (
        <div className={`toast-notification ${saveStatus === "success" ? "toast-success" : "toast-error"}`}>
          {saveStatus === "success" ? <BsCheckCircleFill /> : <BsXCircleFill />}
          <span>{saveStatus === "success" ? "Profile updated successfully!" : "Failed to save. Please try again."}</span>
        </div>
      )}
    </div>
  );
}
